import { proxy } from 'valtio';

import { type SidebarPanel } from '@canvas/model/sidebar-panel';

export const defaultSidebarPanel = { panel: 'none' as const };

export const currentSidebarPanel: SidebarPanel = proxy(defaultSidebarPanel);

export const updateSidebarPanel = (panel: SidebarPanel['panel']) =>
  (currentSidebarPanel.panel = panel);

export const resetSidebarPanel = () =>
  (currentSidebarPanel.panel = defaultSidebarPanel.panel);
